function filterWidgetsWithNonExistingMetrics (widgets, statMetrics) {
  const metricsSet = new Set(Object.keys(statMetrics));
  if (!metricsSet.size) {
    return widgets;
  }

  const filteredWidgets = [];

  widgets.forEach(w => {
    const dsType = w.dsType;
    if (dsType !== 'statistics') {
      filteredWidgets.push(w);
      return;
    }

    // skip widget if at least one metric from metricsList is not available
    let metricsList = w.dsStatisticsParams.metrics;
    if (w.dsStatisticsParams.planFactMetrics) {
      metricsList = w.dsStatisticsParams.planFactMetrics.map(m => m.metric);
    }
    if (metricsList) {
      let _metricsList = metricsList.filter(m => metricsSet.has(m));
      if (_metricsList.length === 0 || _metricsList.length !== metricsList.length) {
        return;
      }
      w.metricsList = _metricsList;
    }

    // skip widget if metric is not available
    const metric = w.dsStatisticsParams.metric;
    if (metric && metric !== '{metric}' && !metricsSet.has(metric)) {
      return;
    }

    filteredWidgets.push(w);
  });

  return filteredWidgets;
}

export default filterWidgetsWithNonExistingMetrics;
